import IconCommon from '@/components/Common/DesignSystem/Icon/IconCommon';
import { RaffleDealStoreCtx } from '@/stores/RaffleDealStore';
import { observer } from 'mobx-react-lite';
import React, { useContext, useState } from 'react';

import styles from './RaffleDealNotice.module.scss';

const RaffleDealNotice: React.FC = () => {
  const [isExtended, setIsExtended] = useState(false);

  const store = useContext(RaffleDealStoreCtx);
  const { caution } = store.PromotionData;
  const { content, detailContent } = caution || {};

  if (!caution) return null;

  return (
    <section className={styles.container}>
      {content && <div className={styles.htmlArea} dangerouslySetInnerHTML={{ __html: content }} />}

      {detailContent && (
        <>
          <div className={styles.extendButton} onClick={() => setIsExtended((v) => !v)}>
            {isExtended ? '접기' : '펼치기'}
            {isExtended ? <IconCommon type="icon_arrowup_fill" /> : <IconCommon type="icon_arrowdrop_fill" />}
          </div>
          <div className={isExtended ? '' : styles.folded}>
            {<div className={styles.htmlArea} dangerouslySetInnerHTML={{ __html: detailContent }} />}
          </div>
        </>
      )}
    </section>
  );
};

export default observer(RaffleDealNotice);
